import { render, staticRenderFns } from "./WineryPictures_Desktop.vue?vue&type=template&id=2743e1c4&scoped=true&"
import script from "./WineryPictures_Desktop.vue?vue&type=script&lang=js&"
export * from "./WineryPictures_Desktop.vue?vue&type=script&lang=js&"
import style1 from "./WineryPictures_Desktop.vue?vue&type=style&index=1&id=2743e1c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2743e1c4",
  null
  
)

export default component.exports